const INITIAL_STATE = {
  loadingUltimoTermo: false,
  urlRedirect: "",
  error: null,
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
      case 'RESET_STATE_ENTIDADE_ASSOCIATIVA':
        return INITIAL_STATE

      case 'TRY_FETCH_ULTIMO_TERMO':
        return {...state, error: null, loadingUltimoTermo: true}

      case 'SUCCESS_FETCH_ULTIMO_TERMO': 
        return { ...state, urlRedirect: "/mensalidade-entidade/pdf-download", loadingUltimoTermo: false }

      case 'ERROR_FETCH_ULTIMO_TERMO': 
        return { ...state, urlRedirect: action.payload, loadingUltimoTermo: false }        

      default:
        return state;
    }
}
